module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Les récompenses","errorInitialFetching":"Impossible de récupérer les données nécessaires","loadingText":"Chargement des récompenses..."},"en":{"title":"Rewards","errorInitialFetching":"Unable to fetch server data","loadingText":"loading rewards..."}}')
  delete Component.options._Ctor
}
